import boot from "@boot/index";

const app = boot();

export default app;